export const isProduction = process.env.NODE_ENV === 'production'

export const isServer = typeof window === 'undefined'

export const isDebug = !isProduction && !isServer && window.location.search.includes('debug')

export const isIeOrEdge = !isServer && (/Trident|Edge/.test(navigator.userAgent))

export const isMobile = !isServer && (/Android|iPad|iPhone/.test(navigator.userAgent))
